// @flow

import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';

import chart from '../images/chart.jpg';
import Grid from 'material-grid/dist/Grid/Grid';
import Cell from 'material-grid/dist/Grid/Cell';

const dialogProps = [
  {
    content: (
      <div>
        <p>
          <strong>PRECE</strong> (<strong>PR</strong>edicting <strong>E</strong>xtra<strong>C</strong>apsular <strong>E</strong>xtension) is a tool aimed to predict and characterize the risk of extracapsular extension (<strong>ECE</strong>) in patients affected by prostate cancer.
        </p>
        <p>
          The aim is to provide a useful tool for preoperative surgical planning to appropriately grade the nerve sparing approach during radical prostatectomy.
        </p>
        <p>
          The <strong>PRECE</strong> tool is based on five multivariable logistic models on a cohort of 6360 patients affected by prostate cancer and undergone radical prostatectomy.<br/>
          The Areas Under Curve (<strong>AUC</strong>) of the <strong>PRECE</strong> tool predictions range from <em>0.81</em> to <em>0.90</em>.
        </p>
        <h3>The tool provides the following information:</h3>
        <ul>
          <li>Prediction of side specific overall risk of ECE;</li>
          <li>Specific prediction of risk of ECE at 1, 2, 3, 4 mm;</li>
          <li>A decision rule:<br />
            <ul>
              <li><strong>Red areas</strong>: suggest the surgeon that there is a very high (<span className="dark-red">dark&nbsp;red</span>) and high (<span className="light-red">light&nbsp;red</span>) chance to find disease at that specific distance out of the prostate;</li>
              <li><strong>Yellow area</strong>: area of uncertainty;</li>
              <li><strong>Green areas</strong>: suggest the surgeon that there is a very high (<span className="dark-green">dark&nbsp;green</span>) and high (<span className="light-green">light&nbsp;green</span>) chance to <strong>not</strong> find disease at that specific distance out of the prostate.</li>
            </ul>
          </li>
        </ul>
      </div>
    ),
    style: { top: 0, left: 0 }
  },
  {
    content: (
      <div>
        <p>
          The <strong>12 cells</strong> of this table represent <strong>12 biopsy cores</strong> and their position in the prostate:
        </p>
        <ul>
          <li>Input the <strong>percentage of positivity</strong> in the appropriate location;</li>
          <li>Input <strong>0</strong> for negative biopsies;</li>
          <li>Leave the field <strong>empty</strong> if there are no cores in that location.</li>
        </ul>
      </div>),
    style: { top: -150, left: '-25%', width: '35%', maxWidth: 'none' }
  },
  {
    content: (
      <div>
        <p>
          Input <strong>Gleason sum</strong> for <strong>each positive core</strong> in the corresponding area of the prostate.
        </p>
      </div>),
    style: { top: -150, left: '25%', width: '35%', maxWidth: 'none' }
  },
  {
    content: (
      <div>
        <p>
          Finally, fill out the <strong>clinical stage</strong>, <strong>age</strong> of the patient and <strong>PSA</strong>.
        </p>
      </div>
    ),
    style: {top: 200, width: '35%', maxWidth: 'none' }
  },
  {
    content: (
      <div>
        <Grid>
          <Cell col={6}>
            <p>
              The final output for each lobe will be shown as in the chart on the right:
            </p>
            <ul>
              <li>
                5 possible areas of risk (<span className="dark-red">dark&nbsp;red</span>, <span className="light-red">light&nbsp;red</span>, <span className="yellow">yellow</span>, <span className="light-green">light&nbsp;green</span>, <span className="dark-green">dark&nbsp;green</span>)
              </li>
              <li>
                One triangle with the exact probability and range of risk of ECE at that width out of the prostate.
              </li>
            </ul>
            <p>
              <em><strong>In the example:</strong> the chart shows a consistent risk of ECE (about 35%) with uncertainty at 1 and 2 mm and a pretty safe area at 3 mm (probability of ECE at 3 mm 3.4%).</em>
            </p>
          </Cell>
          <Cell col={6}>
            <img src={chart} className="chart" alt="chart" />
          </Cell>
        </Grid>
        <span className="warning">All results from these tools should be discussed with a physician. The PRECE tool results are based on data from a study conducted at a high-volume medical center and might not be reproducible in other clinical contexts.</span>
      </div>
    ),
    style: { width: '63%', maxWidth: 'none' }
  }
];

class Tutorial extends Component {

  state: {
    step: number;
    tutorialDisabled: boolean;
  };



  constructor(props: Props) {
    super(props);

    this.state = {
      step: 0,
      tutorialDisabled: false,
    }
  };

  handleNext = () => {
    this.setState({step: this.state.step + 1});
  }

  handlePrevious = () => {
    this.setState({step: this.state.step - 1});
  }


  render() {
    const actions = [
      <FlatButton
        label="Previous"
        primary={true}
        onTouchTap={this.handlePrevious}
        disabled={this.state.step === 0}
      />,
      <FlatButton
        label="Next"
        primary={true}
        onTouchTap={this.handleNext}
        keyboardFocused={true}
        disabled={this.state.step === dialogProps.length - 1}
      />,
      <FlatButton
        label="Dismiss"
        primary={true}
        onTouchTap={this.props.handleDismiss}
      />,
    ];

    return (
      <Dialog
        title="How to use this tool"
        open={this.props.open}
        contentStyle={dialogProps[this.state.step].style}
        actions={actions}
      >
        {dialogProps[this.state.step].content}
        {this.props.tutorialDisableShow &&
          <Checkbox
            label="Do not show this tutorial on your next site visit"
            labelPosition="left"
            labelStyle={{textAlign: "right"}}
            onCheck={this.props.handleCheck}
          />
        }
      </Dialog>
    );
  }
}

export default Tutorial;



/** WEBPACK FOOTER **
 ** ./src/Components/Tutorial.js
 **/